import React, { Component } from 'react';
import { EventConsumer } from '../core/providers/EventProvider';
import EventSnack from './EventSnack';
import GS from '../grafsync/grafsync';
import CommonIriDisplay from '../application-core/CommonIriDisplay';
import { getProjectFromGraph } from './utils/utils';
import { BN_NAMESPACE } from './utils/constants';

class EventBar extends Component {

    render() {

        return (
            <EventConsumer>
                {({ event }) => {
                    if (event) {
                        // Dont event any blank nodes
                        if (event.data && event.data.channel && event.data.channel.startsWith(BN_NAMESPACE)) return null;
                        let additionalText = "";
                        let report = false;
                        let message = "";
                        switch (event.type) {
                            case GS.EVENTS.EVENT_RESOURCE_CREATE:
                                message = "Another user just created:";
                                break;
                            case GS.EVENTS.EVENT_EDIT:
                                message = event.data.text.join(". ");
                                break;
                            case GS.EVENTS.EVENT_CONCURRENT_EDIT:
                                message = "A conflicting concurrent edit has been made.";
                                additionalText = event.data.text.join(". ");
                                report = true;
                                break;
                            default:
                        }
                        let link;
                        let componentLink;
                        if (event.type === GS.EVENTS.EVENT_RESOURCE_CREATE) {
                            switch (event.data.class) {
                                case 'http://www.w3.org/2008/05/skos-xl#Label':
                                    additionalText = "This is a SKOS-XL Label.";
                                    report = true;
                                    break;
                                case "http://www.w3.org/2004/02/skos/core#Concept":
                                    additionalText = "This is a SKOS Concept.";
                                    report = true;
                                    break;
                                case "https://grafsync.graphifi.com/schema/gs/Resource":
                                    additionalText = "This is a Resource.";
                                    report = true;
                                    break;
                                case "http://www.w3.org/2002/07/owl#Class":
                                    additionalText = "This is an OWL Class.";
                                    report = true;
                                    break;
                                case "http://www.w3.org/2002/07/owl#ObjectProperty":
                                    additionalText = "This is an OWL Object Property.";
                                    report = true;
                                    break;
                                case "http://www.w3.org/2002/07/owl#DatatypeProperty":
                                    additionalText = "This is an OWL Datatype Property.";
                                    report = true;
                                    break;
                                case "http://www.w3.org/2002/07/owl#AnnotationProperty":
                                    additionalText = "This is an OWL Annotation Property.";
                                    report = true;
                                    break;
                                case "http://www.w3.org/2002/07/owl#NamedIndividual":
                                    additionalText = "This is an OWL Named Individual.";
                                    report = true;
                                    break;
                                case "http://www.w3.org/2000/01/rdf-schema#Datatype":
                                    additionalText = "This is a RDFS Datatype.";
                                    report = true;
                                    break;
                                default:
                            }
                            if (report) {
                                link = <CommonIriDisplay
                                    id={event.data.channel}
                                    key={event.data.channel}
                                    compact={true}
                                    projectIRI={getProjectFromGraph(event.data.graph)}
                                    handleNotAvailable={true}
                                    forceNewTab={true}
                                    loadComponents={true}
                                    graph={event.data.graph}
                                    viewLang={this.props.defaultLang}
                                    defaultLang={this.props.defaultLang} />;
                                const component = event.data.jsonld.inDataset || event.data.jsonld.inScheme || event.data.jsonld.visibility || event.data.jsonld.isDefinedBy;
                                if (component) {
                                    const componentIRI = Array.isArray(component) ? component[0] : component;
                                    if (componentIRI) {
                                        componentLink = <CommonIriDisplay
                                            id={componentIRI}
                                            key={componentIRI}
                                            compact={true}
                                            projectIRI={getProjectFromGraph(event.data.graph)}
                                            handleNotAvailable={true}
                                            loadComponents={true}
                                            forceNewTab={true}
                                            graph={event.data.graph}
                                            viewLang={this.props.defaultLang}
                                            defaultLang={this.props.defaultLang} />;
                                    }
                                }
                            }
                        }
                        else if (event.type === GS.EVENTS.EVENT_EDIT && event.data.editType === "DeleteResource") {
                            if (GS.isLoaded(event.data.channel, event.data.graph)) {
                                const data = GS.data(event.data.channel, event.data.graph);
                                const dataTypes = data.type ?
                                    Array.isArray(data.type) ?
                                        data.type
                                        :
                                        [data.type]
                                    :
                                    [];
                                // We don't report on application types, such as tasks, suggestions, shapes
                                const isApplicationType = dataTypes.some(dt => dt.includes("graphifi") || dt.includes("PropertyShape") || dt.includes("NodeShape"));
                                report = !isApplicationType;
                                if (report) {
                                    link = <CommonIriDisplay
                                        id={event.data.channel}
                                        compact={true}
                                        projectIRI={getProjectFromGraph(event.data.graph)}
                                        handleNotAvailable={true}
                                        loadComponents={true}
                                        forceNewTab={true}
                                        graph={event.data.graph}
                                        viewLang={this.props.defaultLang}
                                        defaultLang={this.props.defaultLang} />;
                                }
                            }
                        }
                        if (!report) return null;
                        if (componentLink) additionalText += " It has been added to:";
                        let additionalMessage = additionalText !== "" ? <p data-test="additional-text" style={{ marginTop: 6, marginBottom: 12 }}>{additionalText}</p> : null;
                        return <EventSnack
                            key={event.data.channel}
                            message={
                                <div>
                                    <p data-test="snack-message">{message}</p>
                                    {link}
                                    {additionalMessage}
                                    {componentLink}
                                </div>
                            }
                        />;
                    }
                }
                }
            </EventConsumer >
        );
    }
}

export default EventBar;